module.exports = __webpack_public_path__ + "img/surveillance_scene.b4405b4f.png";